import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <a href="https://github.com/Mubbyrex" className="link footer__link">
        Created By Mubarak O. Ibrahim
      </a>
    </footer>
  );
};

export default Footer;
